import { Form, InputNumber } from 'antd';

import { seatClasses } from '../../../../utils/constants';
import useTranslation from '../../../hooks/translation/useTranslation';

import { ReactComponent as Plus } from '../../../../resources/images/svg/plus.svg';
import { ReactComponent as Minus } from '../../../../resources/images/svg/minus.svg';

import './ClassSeatsNumberInput.scss';
import { useAuth } from '../../../contexts/userContext/userContext';

function ClassSeatsNumberInput({
  form,
  name,
  price,
  label,
  disabled,
  watchName,
  className,
  seatClassId,
}) {
  const { user } = useAuth();
  const { trans } = useTranslation();
  const value = Form.useWatch((watchName || name), form);

  const handleChange = (newVal) => {
    if (Number(newVal) > 0 && Number.isInteger(newVal)) {
      form.setFieldValue(watchName || name, newVal);
    } else {
      form.setFieldValue(watchName || name, 0);
    }
  };

  const currentClassSrc = seatClasses?.[seatClassId];

  return (
    <Form.Item name={name} style={{ marginBottom: 0 }}>
      <div className={`bg-white flex items-center px-5 sm:px-11 h-[109px] font-bold rounded-2xl ${className}`}>
        <div className="flex items-center gap-5 flex-grow">
          {currentClassSrc
              && <img className="w-8 h-8" src={currentClassSrc} alt="seat class logo" />}
          <span className="text-sm sm:text-base">{seatClassId === '2-12' ? trans('wheelchair') : trans(label)}</span>
        </div>
        <div className="flex gap-4 lg:gap-16">
          <div className="text-xl sm:text-2xl">
            {price}
            {' '}
            {trans('gel')}
          </div>
          <div className="flex items-center justify-center gap-3">
            <button
              type="button"
              disabled={value < 1}
              onClick={() => handleChange(Number(value) - 1)}
              className={`class-seat-button ${value < 1 && 'disabled'}`}
            >
              <Minus />
            </button>
            {user?.type === 'legal'
              ? (
                <InputNumber
                  bordered={false}
                  className="transparent-number-input !text-base !h-10"
                  min={0}
                  controls={false}
                  onChange={(val) => handleChange(val)}
                  onBlur={() => {
                    if (value === '' || value === null) {
                      handleChange(0);
                    }
                  }}
                  value={value}
                />
              ) : (
                <>
                  <input type="number" className="hidden" />
                  <span className="text-base leading-4 flex items-center">{value}</span>
                </>
              )}
            <button
              type="button"
              onClick={() => handleChange(Number(value) + 1)}
              className="class-seat-button"
              disabled={disabled}
            >
              <Plus />
            </button>
          </div>
        </div>
      </div>
    </Form.Item>

  );
}
export default ClassSeatsNumberInput;
